import { CUSTOM_EVENT_TYPE } from 'constants/types'

export const dispatchAnalyticsClickEvent = (
    searchFormInput: HTMLInputElement,
    sourceName: string,
    sourceLayoutElement: string,
    inputText: boolean
): void => {
    /**
     * Dipatch search analytic event
     */
    if (searchFormInput && searchFormInput.value) {
        let detail = {
            event_name: 'User Interaction Click',
            control_fields: {
                mparticle: {
                    keys: {
                        click_source_type: 'Click Source Type',
                        click_source_name: 'Click Source Name',
                        click_source_layout_element:
                            'Click Source Layout Element'
                    },
                    mp_event_type: 'Navigation',
                    extra_keys: [
                        'Click Source Vertical Position %',
                        'Click Source Vertical Position Pixels'
                    ]
                }
            },
            click_source_type: 'button',
            click_source_name: sourceName,
            click_source_layout_element: sourceLayoutElement
        }
        // add input text to object
        if (inputText) {
            detail.control_fields.mparticle.keys = {
                ...detail.control_fields.mparticle.keys,
                ...{ click_input_text: 'Click Input Text' }
            }
            detail = {
                ...detail,
                ...{ click_input_text: searchFormInput.value }
            }
        }
        //dispatch Analytic Event
        document.dispatchEvent(new CustomEvent(CUSTOM_EVENT_TYPE, { detail }))
    }
}
